/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Button, Typography, IconButton, Drawer, List, ListItem, ListItemText, useMediaQuery, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import { NavLink, useLocation } from 'react-router-dom';
import MenuItem from './MenuItem';
import './Navbar.css';
import Menu from '@mui/material/Menu';
import { fontSize } from '@mui/system';

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      marginTop:theme.spacing(0),
      marginRight: theme.spacing(3),
      marginLeft: theme.spacing(3),
    },
    fontFamily: 'Helvetica , sans-serif'
  },
  navbar: {
    minHeight: 10,
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    marginTop: theme.spacing(0),
    marginLeft: theme.spacing(2),
    backgroundColor: '#ffffff',
  },
  logo: {
    height: 40,
    backgroundColor: '#ffffff'
  },
  menuItems: {
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(2),
    },
    backgroundColor: '#ffffff',
    color:'#000000'
  },
  drawerLogo: {
    height: 30,
    margin: theme.spacing(2),
  },
  drawerList: {
    width: 250,
  },
  drawerButton: {
    margin: theme.spacing(2),
  },
  active: {
    color: '#61dafb', // Change the text color here
    backgroundColor: 'white', // Change the background color here
    //textDecoration: 'none',
    fontWeight: 600
  },
  title: {
    color: '#000000',
    fontWeight: 'bold',
    fontSize:20
  }
}));

const MainMenu = () => {
  const classes = useStyles();
  const [openDrawer, setOpenDrawer] = useState(false);
  const isMobile = window.innerWidth <= 768;

  const handleDrawerToggle = () => {
    setOpenDrawer(!openDrawer);
  };

  const location = useLocation(); // Get the current location
  const isActiveRoute = (route) => {
    return location.pathname.startsWith(route);
  };
  

  const handleClick = () => {
    handleDrawerToggle();
  };


    //Setting the Visibility of the search button to true or false
    const[visible, setVisible] =useState(true);
    const[width, setWidth] = useState(window.innerHeight);
  
    const handleVisibility=()=>{
      setVisible(prev => !prev);
    };
  
    const handleWidth =()=>{
      setWidth(window.innerWidth);
    };
  
  return (
    <Toolbar className={classes.navbar}>
      <div className={classes.logo}>
        <img alt="Logo" src="/images/logos/logo.jpeg" className={classes.logo} />
      </div>

      {isMobile && (
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={handleDrawerToggle}
          className={classes.menuButton}
        >
          <MenuIcon />
        </IconButton>
      )}
      {!isMobile && (
        <>
          <div className={classes.menuItems}>
            <div className={classes.title}><NavLink to="/" style={{textDecoration: 'none', color: '#000000'}}>HOME</NavLink></div>
            {MenuItem.slice(0, 5).map((page) => (
              <NavLink
                //color="primary"
                variant="outline"
                rounded
                key={page.title}
                component={Button}
                to={page.to}
                className={isActiveRoute(page.to) ? classes.active : ''} // Apply the active class conditionally
                onClick={handleClick}
                style={{textDecoration: 'none', fontSize:18}}
              >
                {page.title}
              </NavLink>
            ))}
          </div>
        </>
      )}

      {isMobile && (
        <Drawer
          anchor="left"
          open={openDrawer}
          onClose={handleDrawerToggle}
          classes={{ paper: classes.drawerList }}
        >
          <img
            alt="Logo"
            src="/images/logos/logo.jpeg"
            className={classes.drawerLogo}
          />
          <List>
            {MenuItem.slice(0, 5).map((page) => (
              <>
                <Button
                  key={page.title}
                  component={NavLink}
                  to={page.to}
                  className={isActiveRoute(page.to) ? classes.active : ''} // Apply the active class conditionally
                  onClick={handleClick}
                  //className={classes.drawerButton}
                >
                  {page.title}
                </Button>
                <br />
              </>
            ))}
          </List>
        </Drawer>
      )}
    </Toolbar>
  );
};

export default MainMenu;
